module.exports = __webpack_public_path__ + "static/media/thankyou-img.bbe30871.svg";